<template>
  <div class="delay-exam">
    <Header title="巡考查询" type="0" route="/homeIndex"></Header>
    <div class="search-info">
      <div class="sem-drop">
        <div @click="semPicker = true">
          <p>{{ this.semester }}</p>
          <i></i>
        </div>
        <div @click="actPicker = true">
          <p>{{ this.activity }}</p>
          <i></i>
        </div>
        <div @click="sfxkPicker = true">
          <p>{{ this.xktext }}</p>
          <i></i>
        </div>
      </div>
      <van-popup v-model="semPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="option1"
          @cancel="semPicker = false"
          @confirm="semConfirm"
          :swipe-duration="500"
          :item-height="35"
        />
      </van-popup>
      <van-popup v-model="actPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="option2"
          @cancel="actPicker = false"
          @confirm="actConfirm"
          :swipe-duration="500"
          :item-height="35"
        />
      </van-popup>
      <van-popup v-model="sfxkPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="option3"
          @cancel="sfxkPicker = false"
          @confirm="sfxkConfirm"
          :swipe-duration="500"
          :item-height="35"
        />
      </van-popup>
    </div>
    <NOdata v-if="this.allWarnList.length == 0" title="暂无巡考数据~"></NOdata>
    <div v-else>
      <a class="grey-contain" v-for="(item, index) in allWarnList" :key="index">
        <div>
          <p class="contain-txt">{{ item.kcmc }}</p>
          <p class="contain-txt1">时间：{{ item.kssj }}</p>
          <p class="contain-txt1">地点：{{ item.kscdmc }}</p>
          <p class="contain-txt1">监考人员：{{ item.jkry }}</p>
          <p class="contain-txt1">巡考人员：{{ item.xkryxm }}</p>
          <p class="contain-txt1">备注：{{ item.bz }}</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      allWarnList: [],
      semPicker: false,
      actPicker: false,
      sfxkPicker: false,
      semester: "学年学期",
      curSemester: "",
      activity: "学期类别",
      option1: [
        {
          text: "学年学期",
          value: 0,
          index: "",
        },
      ],
      option2: [
        {
          text: "学期类别",
          value: 0,
          index: "",
        },
      ],
      option3: [
        {
          text: "未巡考",
          value: 0,
          index: 0,
        },
        {
          text: "已巡考",
          value: 1,
          index: 1,
        },
      ],
      activityId: "",
      xkflag: 0,
      xktext: "未巡考",
    };
  },
  created() {
    this.getSemList();
    this.itemSelect();
    this.getMain();
  },
  methods: {
    async getSemList() {
      let concatList = [];
      const res = await Api.getSemesterList();
      res.data.forEach((item, index) => {
        concatList[index] = {
          text: item.semesterName,
          value: index + 1,
          index: item.semesterId,
        };
      });
      this.option1 = this.option1.concat(concatList);
    },
    async itemSelect() {
      const res = await Api.getXqlb();
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          text: item.xqlbmc,
          value: index + 1,
          index: item.xqlbid,
        };
      });
      this.option2 = this.option2.concat(concatList);
    },
    async getMain() {
      const res = await Api.getCurrentTerm();
      this.curSemester = res.data[0].semesterId;
      this.semester = res.data[0].semesterName;
      console.log(this.curSemester)
      console.log(this.semester)
      this.getSlow();
    },
    async getSlow() {
      const params = {
        xnxq01id: this.curSemester,
        xqlb: this.activityId,
        xkflag: this.xkflag,
      };
      const res = await Api.getJsxklist(params);
      this.allWarnList = res.data;
    },
    async semConfirm(e, val) {
      this.semPicker = false;
      this.semester = e.text;
       this.curSemester = e.index;
      this.getSlow();
    },
    async actConfirm(e, val) {
      this.actPicker = false;
      this.activity = e.text;
      this.activityId = e.index;
      this.getSlow();
    },
    async sfxkConfirm(e, val) {
      this.sfxkPicker = false;
      this.xktext = e.text;
      this.xkflag = e.index;
      this.getSlow();
    },
  },
};
</script>

<style lang="less" scoped>
.delay-exam .grey-contain .contain-txt {
  line-height: 22px;
  margin: 4px 0;
}
.delay-exam .grey-contain .contain-txt1 {
  line-height: 17px;
  margin: 4px 0;
}
.search-info {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid @attendance-border-color-6;
  padding: 20px 0 7px;
}
.search-info input {
  width: 40%;
  text-align: center;
  padding: 10px 0;
}
.grey-contain:last-child {
  margin-bottom: 80px;
}
.search-info .sem-drop,
.search-info .sem-drop div {
  display: flex;
  align-items: center;
  color: @attendance-color-2;
  font-size: 14px;
  justify-content: center;
}
.search-info .sem-drop {
  width: 80%;
}
.search-info .sem-drop > div {
  width: 45%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-info .sem-drop p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}
.search-info .sem-drop > div {
  position: relative;
}
.search-info .sem-drop > div i {
  background: url(../../../../static/img/Triangle.png) no-repeat center;
  width: 10px;
  height: 10px;
  background-size: 10px 8px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Invigilate/xkcx.vue